module.exports = __webpack_public_path__ + "ae090d86317858ce4b34ff344331c419.svg";